import React from "react";
import {
  formatVehicleName,
  formatVehicleNameOnly,
  getVehicleCodeName,
} from "../../utils/vehicleDisplayName";

/**
 * Renders a full vehicle name with wrap-friendly styling (max 2 lines).
 * When both code and name exist, code stays on one line and the name wraps
 * underneath the name (not under the model code).
 */
export default function VehicleName({
  value,
  modelCode,
  modelName,
  nameOnly = false,
  fallback = "",
  className = "",
  title,
  children,
  ...rest
}) {
  // Plain children string: keep as single block
  if (children != null && (typeof children === "string" || typeof children === "number")) {
    const text = String(children);
    if (!text) return null;
    return (
      <span
        className={`vehicle-name vehicle-name--plain ${className}`.trim()}
        title={title != null ? title : text}
        {...rest}
      >
        {text}
      </span>
    );
  }

  if (nameOnly) {
    const text =
      modelName != null && modelName !== ""
        ? String(modelName)
        : formatVehicleNameOnly(value, fallback);
    if (!text) return null;
    return (
      <span
        className={`vehicle-name vehicle-name--plain ${className}`.trim()}
        title={title != null ? title : text}
        {...rest}
      >
        {text}
      </span>
    );
  }

  const { code, name } = getVehicleCodeName(value, {
    code: modelCode,
    name: modelName,
  });
  const full = formatVehicleName(value, {
    code: modelCode,
    name: modelName,
    fallback,
  });

  if (!full) return null;

  // Both parts: keep code fixed, wrap name under itself
  if (code && name) {
    return (
      <span
        className={`vehicle-name vehicle-name--split ${className}`.trim()}
        title={title != null ? title : full}
        {...rest}
      >
        <span className="vehicle-name__code">{code}&nbsp;-&nbsp;</span>
        <span className="vehicle-name__label">{name}</span>
      </span>
    );
  }

  return (
    <span
      className={`vehicle-name vehicle-name--plain ${className}`.trim()}
      title={title != null ? title : full}
      {...rest}
    >
      {full}
    </span>
  );
}
